import { Cell } from '../grid/Cell'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  isHighContrast: boolean
}

export const InfoModal = ({ isOpen, handleClose, isHighContrast }: Props) => {
  return (
    <BaseModal title="How to play Hurdle" isOpen={isOpen} handleClose={handleClose}>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      Each Hurdle puzzle contains a secret 5-letter word you'll need to solve every day.<br /><br />
      You have six tries to get it right. After each guess, the tiles' colors will indicate how close your guess was to the word.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell
          isHighContrast={isHighContrast}
          isInstructions={true}
          isRevealing={true}
          isCompleted={true}
          value="P"
          status="correct"
        />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="O" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="I" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="N" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="T" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      If the tile turns green, it's the correct letter in the right spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="L" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="A" />
        <Cell isHighContrast={isHighContrast} isInstructions={true}
          isRevealing={true}
          isCompleted={true}
          value="B"
          status="present"
        />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="O" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="R" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      If the tile turns yellow, the letter is in the word but not in the right spot.
      </p>

      <div className="flex justify-center mb-1 mt-4">
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="P" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="E" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="A" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} isRevealing={true} isCompleted={true} value="K" status="absent" />
        <Cell isHighContrast={isHighContrast} isInstructions={true} value="S" />
      </div>
      <p className="text-sm text-gray-500 dark:text-gray-300">
      If the tile turns grey, the letter is not found in the word.
      </p>
      <br />
      <p className="text-sm text-gray-500 dark:text-gray-300">
      The 5th and final Hurdle puzzle will be prefilled with the answers from the previous 4 Hurdles. You only have 2 chances to solve it.</p>
      <p className="mt-6 italic text-sm text-gray-500 dark:text-gray-300">
      Enjoy this popular word game with a twist – play Hurdle today


      </p>
      <p style={{ color: "white", fontSize: "10px", textAlign: "right"}}>v0.15</p>
    </BaseModal>
  )
}
